module.exports = __webpack_public_path__ + "img/file-transfer.22c8eb68.svg";